import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
export const lionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  &, .mediaFirstImpactSmall, .mediaLastImpactSmall {
    .title {
      ${chroma.typography.display3};
      color: ${paletteTokens.bladetext2};
    }
  }
`;
//# sourceMappingURL=index.js.map